import React from 'react'
import cx from 'classnames'
import IconSVG from 'svg-inline-react'

import LoadingDots from 'components/shared/LoadingDots'
import savedCheckSrc from '!svg-inline!images/icons/check-mark-icon.svg'
import saveFailedSrc from '!svg-inline!images/svg/redx.svg'

import { Div, Button } from '@driftt/tide-core-legacy'

import './style.styl'

const ButtonUnsaved = ({ isEnabled, handleSave, isOneTimeEmailPlaybook }) => (
  <Button type="primary" onClick={handleSave}>
    {isEnabled ? 'Publish' : 'Save'} {isOneTimeEmailPlaybook ? 'Draft' : 'Changes'}
  </Button>
)

const ButtonSaved = () => (
  <Div className="playbook-save-status flex-center">
    <Div className="flex playbook-save-status-label">
      <IconSVG src={savedCheckSrc} /> Saved
    </Div>
  </Div>
)

const ButtonSaving = () => (
  <Div className="playbook-save-status flex-space-between loading">
    <Div>Saving</Div> <LoadingDots />
  </Div>
)

const ButtonSaveFailed = () => (
  <Div className="playbook-save-status flex-center">
    <Div className="flex playbook-save-status-label">
      <IconSVG src={saveFailedSrc} /> Save Failed
    </Div>
  </Div>
)

export const ArchivedStatus = () => (
  <Div className="playbook-save-status-archived">You are editing an <strong>Archived Playbook</strong>. Your changes will not be saved.</Div>
)

export const SaveStatus = ({ isSaved, isSaving, saveFailed, handleSavePlaybookDraft, ...props }) => {
  return (
    <Div className="drift-form">
      {isSaving && <ButtonSaving />}
      {!isSaving && !isSaved && <ButtonUnsaved {...props} handleSave={handleSavePlaybookDraft} />}
      {!isSaving && isSaved && !saveFailed && <ButtonSaved />}
      {!isSaving && isSaved && saveFailed && <ButtonSaveFailed />}
    </Div>
  )
}

export const AutoSaveStatus = ({ isSaving, saveFailed, className }) => (
  <Div className={cx('playbook-save-status', className, 'flex-center', { loading: isSaving, failed: saveFailed })}>
    {!saveFailed &&
      <Div className="flex playbook-save-status-label">
        <IconSVG src={savedCheckSrc} /> Saved
      </Div>
    }
    {saveFailed &&
      <Div className="flex playbook-save-status-label">
        <IconSVG src={saveFailedSrc} /> Save Failed
      </Div>
    }
    <LoadingDots />
  </Div>
)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/SaveStatus/component.js